"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ConditionalWrapper;

var _propTypes = _interopRequireDefault(require("prop-types"));

// deps

/**
 * Ajoute de manière conditionnelle un wrapper autour d’un composant si le prop `hasWrapper` est à `true`.
 * Sinon, retourne juste le composant sans wrapper.
 */
function ConditionalWrapper(props) {
  const {
    hasWrapper,
    wrapper,
    children
  } = props;
  return hasWrapper ? wrapper(children) : children;
}

ConditionalWrapper.propTypes = {
  children: _propTypes.default.node,
  wrapper: _propTypes.default.func.isRequired,
  hasWrapper: _propTypes.default.bool.isRequired
};